<script setup lang="ts">
import AppHeader from "@/components/header/AppHeader.vue";
import TaskPaneView from "@/views/TaskPaneView.vue";
import { SpeckleSnackbar } from "@haskoning/vue-speckle";
</script>

<template>
  <v-app>
    <AppHeader />
    <v-main class="app-main">
      <div class="app-main__scroll">
        <TaskPaneView />
      </div>
    </v-main>
    <SpeckleSnackbar />
  </v-app>
</template>
<style lang="scss">
// the main file that imports everything related with styles
@use "/src/scss/settings";

html,
body,
#app,
.v-application,
.v-application__wrap {
  --app-header-height: 36px;
  width: 100%;
  height: 100%;
  min-height: 100%;
  overflow: hidden;
  background: rgb(var(--v-theme-onPrimary));
}

.v-application__wrap {
  max-height: 100vh;
}

.v-application,
.v-application__wrap {
  position: fixed;
  inset: 0;
}

.app-main {
  display: flex;
  flex-direction: column;
  position: fixed;
  inset: var(--app-header-height) 0 0;
  flex: none;
  box-sizing: border-box;
  height: auto;
  max-height: none;
  min-height: 0;
  padding: 0 !important;
  overflow: hidden;
  background: rgb(var(--v-theme-onPrimary));
}

.app-main__scroll {
  flex: 1 1 auto;
  height: 100%;
  max-height: 100%;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-color: rgb(var(--v-theme-primary)) transparent;
  scrollbar-width: thin;
  background: rgb(var(--v-theme-onPrimary));
}

.app-main__scroll::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}

.app-main__scroll::-webkit-scrollbar-track {
  background: transparent;
}

.app-main__scroll::-webkit-scrollbar-thumb {
  min-height: 80px;
  border-radius: 100px;
  background: rgb(var(--v-theme-primary));
}
</style>
